import React from 'react'

export default function Header() {

  return (
    <div style={{textAlign: 'left'}}>
      <h1>Simple Critical Infrastructure Maps (SCIM)</h1>
      <p>The Dartboard of Death is a planning tool designed to focus attention on key aspects of disaster mitigation and resilience. The <a href={'http://resiliencemaps.org/'}>concept and original diagram</a> are by <a href={'https://twitter.com/leashless'}>Vinay Gupta</a></p>
      <p>It illustrates 6 ways to die with critical infrastructure plotted geographically from local to global.</p>
    </div>
  )
}